import { useNavigate } from 'react-router-dom';

import { BreadcrumbItem, Icon, SimpleTooltip } from '@eluve/components';

export const BackBreadcrumbItem = () => {
  const navigate = useNavigate();

  return (
    <SimpleTooltip label="Back">
      <BreadcrumbItem
        className="mr-4 cursor-pointer text-text-secondary hover:text-text-primary"
        onClick={() => {
          navigate(-1);
        }}
      >
        <Icon name="ArrowLeft" />
      </BreadcrumbItem>
    </SimpleTooltip>
  );
};
